import theme from '../../theme/theme';

const {
  colors: { subtitle },
} = theme;

const styles = {
  scroll__wheel: {
    height: '70vh',
    overflow: 'auto',
  },

  menu__wrapper: {
    paddingTop: '5%',
    display: 'block',
    flex: 1,
    height: '6em',
  },

  first__row: {
    display: 'flex',
    justifyContent: 'space-between',
    flex: 1,
    paddingLeft: '5%',
    paddingRight: '5%',
  },

  second__row: {
    float: 'right',
  },

  minute: {
    fontSize: '1.2em',
    fontWeight: 600,
  },

  mile: {
    fontSize: '1.2em',
    color: subtitle,
    paddingRight: '1.5em',
  },

  progress__bar: {
    padding: '.05em',
  },

  footer: {
    display: 'flex',
    flex: 1,
    width: '100%',
    position: 'absolute',
    bottom: 0,
    minHeight: '4.625em',
  },
};

export default styles;
